import { Spinner } from "@blueprintjs/core";
import classNames from "classnames";
import React from "react";

import styles from "./loading-page.module.scss";

export interface LoadingPageProps {
  className?: string;
}

export const LoadingPage = ({ className = "" }: LoadingPageProps) => {
  return (
    <div className={classNames(styles.loadingPage, className)}>
      <Spinner className={styles.spinner} />
      <div className={styles.loadingText}>Loading..</div>
    </div>
  );
};
